import React from 'react'
const NoDataToDisplay = () => <p>No data available</p>

export default NoDataToDisplay